import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import HeroBanner from "@/components/dashboard/HeroBanner";
import SovereignPace from "@/components/dashboard/SovereignPace";
import MosCrosswalk from "@/components/dashboard/MosCrosswalk";
import BenefitsVault from "@/components/dashboard/BenefitsVault";
import RecruiterShield from "@/components/dashboard/RecruiterShield";
import TransitionStrike from "@/components/dashboard/TransitionStrike";

export default function Dashboard() {
    return (
        <div data-testid="vanguard-dashboard" className="min-h-screen text-white">
            <Header />
            <main>
                <HeroBanner />
                <SovereignPace />
                <MosCrosswalk />
                <BenefitsVault />
                <RecruiterShield />
                <TransitionStrike />
            </main>
            <Footer />
        </div>
    );
}
